// import { generateConnection } from '@/utils/base'

// export const AUTH_ERRORS = (() => {
//   const CODES = Object.freeze({})

//   const TEXTS = Object.freeze({})

//   return Object.freeze({
//     codes: CODES,
//     texts: TEXTS,

//     textByCode: generateConnection(TEXTS, CODES)
//   })
// })()

export const ADAPTATION_ALLOWED_TOPICS = [
  'articles',
  'all-every-whole',
  'would-vs-used-to',
  'other-another-others',
  'quantifiers',
  'quite-rather',
  'do-does',
  'have-has',
  'mixed-prepositions',
  'prepositions-of-place',
  'prepositions-of-time',
  'there-is-there-are',
  'there-was-there-were',
  'this-that-these-those',
  'verb-to-be'
]
